import functions from '../functions';
import { list } from './list';
import pagination from "../components/pagination";

$(() => {
    listChAt.init();
});

const listChAt = {
    $form: null,
    form: null,
    $listItems: null,
    currentDates: null,
    response: null,
    _params: {
        dateFrom: null,
        nights: null,
        destination: null,
        departureFrom: null,
        guests: null
    },
    init() {
        this.$form = $('.search-form.search-ch-at');
        this.form = this.$form[0];

        if(! this.form) {
            return;
        }

        this.$listItems = $('.list-items');
        this.$pagination = $('.paginate');
        this.$destination = this.$form.find('[name="destination"]');
        this.$departureFrom = this.$form.find('[name="departureFrom"]');
        this.$datepicker = this.$form.find('.datepicker-ch-at');
        this.$dateFrom = this.$datepicker.find('[name="dateFrom"]');
        this.$nights = this.$form.find('[name="nights"]');
        this.$spinner = $('.spinner');
        this.$body = $('body');

        this.$hotelItem = $('.hotel-item').html();

        this.$modalHotel = $('#modalChAtHotel');
        this.$hotel = this.$modalHotel.find('.modal-body').html();
        this.$modalHotel.find('.modal-body').html('');

        this.$modalBooking = $('#modalChAtBooking');
        this.$bookingForm = this.$modalBooking.find('.modal-body').html();
        this.$bookingFormSupplements = this.$modalBooking.find('.calc-item-supplement').html();
        this.$modalBooking.find('.modal-body').html('');

        this.getDestinations().galleryInit().hotelInit().paginateInit().bookingFormInit().bookingInit();

    },
    hotelInit() {

        this.$listItems.on('click', '.hotel', function (e) {
            e.preventDefault();
            const $hotel = $(this);
            const params = JSON.parse($hotel.attr('data-params'));

            listChAt.prepareHotel(params);
        });

        return listChAt;
    },
    galleryInit() {

        listChAt.$modalHotel.on('click', '[data-gallery-id]', function (e) {
            e.preventDefault();
            let galleryId = $(this).attr('data-gallery-id');
            galleryId && showGallery($(this).attr('data-index'), galleryId, true);
            listChAt.$modalHotel.modal('hide');
            $('[data-images-' + galleryId + ']').on('onCloseAfter.lg', function () {
                listChAt.$modalHotel.modal('show');
            });
        });

        return listChAt;
    },
    paginateInit() {

        this.$body.on('click', '[data-page]', function (e) {
            e.preventDefault();
            listChAt.paginate(+$(e.currentTarget).attr('data-page'));
        });

        this.$body.on('click', '[data-more]', function (e) {
            e.preventDefault();
            $(".ch-at-desc-block").css('height', $(".ch-at-desc").height());
            $(this).addClass('d-none');
            $('[data-less]').removeClass('d-none');
        });

        this.$body.on('click', '[data-less]', function (e) {
            e.preventDefault();
            $(".ch-at-desc-block").css('height', 190);
            $(this).addClass('d-none');
            $('[data-more]').removeClass('d-none');
        });

        return listChAt;
    },
    bookingInit() {

        listChAt.$modalBooking.on('click', '.btn-booking-form', function (e) {
            e.preventDefault();
            let finalProductList = JSON.parse(JSON.stringify(listChAt.response.productList));
            let calc = [];
            let params = JSON.parse(listChAt.$modalBooking.find(".table-calculation").attr('data-params'));

            listChAt.$modalBooking.find("*[data-calc]").each(function (index) {
                if ($(this).attr('data-calc') && ! $(this).closest('.calc-item-supplement').length) {
                    let item = JSON.parse($(this).attr('data-calc'));

                    if (item.isOptional && $(this).find('input[type="checkbox"]').is(':checked') || ! item.isOptional) {
                        calc.push(item);
                    }
                }
            });

            for (let a = 0; a < finalProductList.length; a++) {

                console.log(params.productCode, finalProductList[a]);
                if (finalProductList[a].productCode !== params.productCode) {
                    finalProductList.splice(a, 1);
                    a--;
                } else {

                    let optionLists = finalProductList[a].optionList;
                    for (let b = 0; b < optionLists.length; b++) {

                        let componentLists = optionLists[b].componentList;
                        for (let c = 0; c < componentLists.length; c++) {

                            let componentListItem = componentLists[c];

                            if ( ! componentListItem.mandatory) {
                                componentLists.splice(c, 1);
                                c--;
                            } else {

                                let _componentListItem = $.grep(calc, function( item ) {
                                    return componentListItem.componentCode === item.componentCode;
                                });

                                if ( ! _componentListItem.length) {
                                    componentLists.splice(c, 1);
                                    c--;
                                } else {

                                    let productLists = componentListItem.productList;
                                    for (let d = 0; d < productLists.length; d++) {

                                        let productList = productLists[d];
                                        let _productList = $.grep(calc, function( item ) {
                                            return productList.productCode === item.productCode;
                                        });

                                        if ( ! _productList.length) {
                                            productLists.splice(d, 1);
                                            d--;
                                        } else {

                                            if (componentListItem.componentType === "TRANSPORT") {

                                                let option = productList.itineraryList[0].optionList[0];
                                                let priceData = listChAt.response.priceInfoList[option.price.priceId];
                                                let segmentData = listChAt.response.segmentList[option.segmentList[0].idSegment];

                                                option.price.total = priceData.total;
                                                option.price.commissionable = priceData.commissionable;
                                                option.price.nonCommissionable = priceData.nonCommissionable;
                                                option.price.commission = priceData.commission;
                                                option.price.commissionTaxes = priceData.commissionTaxes;

                                                option.segmentList[0].company = segmentData.company;
                                                option.segmentList[0].transportNumber = segmentData.transportNumber;
                                                option.segmentList[0].operatedBy = segmentData.operatedBy;
                                                option.segmentList[0].origin = segmentData.origin;
                                                option.segmentList[0].destination = segmentData.destination;
                                                option.segmentList[0].departureDateTime = segmentData.departureDateTime;
                                                option.segmentList[0].arrivalDateTime = segmentData.arrivalDateTime;
                                                option.segmentList[0].transportType = segmentData.transportType;

                                            } else if (componentListItem.componentType === "SERVICE") {

                                                let serviceOptionLists = productList.serviceOptionList;

                                                for (let e = 0; e < serviceOptionLists.length; e++) {

                                                    let serviceOptionList = serviceOptionLists[e];

                                                    let _serviceOptionList = $.grep(calc, function( item ) {
                                                        return serviceOptionList.serviceCode === item.serviceCode;
                                                    });

                                                    if ( ! _serviceOptionList.length) {
                                                        serviceOptionLists.splice(e, 1);
                                                        e--;
                                                    } else {
                                                        let priceData = listChAt.response.priceInfoList[serviceOptionList.servicePrice.priceId];

                                                        serviceOptionList.servicePrice.total = priceData.total;
                                                        serviceOptionList.servicePrice.commissionable = priceData.commissionable;
                                                        serviceOptionList.servicePrice.nonCommissionable = priceData.nonCommissionable;
                                                        serviceOptionList.servicePrice.commission = priceData.commission;
                                                        serviceOptionList.servicePrice.commissionTaxes = priceData.commissionTaxes;
                                                        serviceOptionList.subcategoryList = [];
                                                    }
                                                }
                                            } else if (componentListItem.componentType === "HOTEL") {

                                                let mealPlanLists = productList.mealPlanList;

                                                for (let f = 0; f < mealPlanLists.length; f++) {

                                                    let mealPlanList = mealPlanLists[f];

                                                    let _mealPlanList = $.grep(calc, function( item) {
                                                        return mealPlanList.mealPlanCode === item.boardCode;
                                                    });

                                                    if ( ! _mealPlanList.length) {
                                                        mealPlanLists.splice(f, 1);
                                                        f--;
                                                    } else {

                                                        let hotelOptionLists = mealPlanList.hotelOptionList;
                                                        for (let g = 0; g < hotelOptionLists.length; g++) {

                                                            let hotelOptionList = hotelOptionLists[g];

                                                            let _hotelOptionList = $.grep(calc, function( item ) {
                                                                return hotelOptionList.roomList[0].roomTypeCode === item.unitCode;
                                                            });
                                                            if ( ! _hotelOptionList.length) {
                                                                hotelOptionLists.splice(g, 1);
                                                                g--;
                                                            } else {
                                                                let priceData = listChAt.response.priceInfoList[hotelOptionList.optionPrice.priceId];

                                                                hotelOptionList.optionPrice.total = priceData.total;
                                                                hotelOptionList.optionPrice.commissionable = priceData.commissionable;
                                                                hotelOptionList.optionPrice.nonCommissionable = priceData.nonCommissionable;
                                                                hotelOptionList.optionPrice.commission = priceData.commission;
                                                                hotelOptionList.optionPrice.commissionTaxes = priceData.commissionTaxes;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                }
            }

            $.post('/services/ch_at/', {action: 'prebooking', 'request' : JSON.stringify(finalProductList)}).then((response) => {
                console.log(response);
            })
        });

        return listChAt;
    },
    bookingFormInit() {

        this.$modalBooking.on('change', '#collectiveTransferDeparture', function (e) {
            if ($(this).is(':checked')) {
                $('#privateTransferDeparture').click();
            }
            listChAt.total();
        });

        this.$modalBooking.on('change', '#collectiveTransferReturn', function (e) {
            if ($(this).is(':checked')) {
                $('#privateTransferReturn').click();
            }
            listChAt.total();
        });

        this.$modalBooking.on('change', '#privateTransferDeparture', function (e) {
            if ($(this).is(':checked')) {
                $('#collectiveTransferDeparture').click();
            }
            listChAt.total();
        });

        this.$modalBooking.on('change', '#privateTransferReturn', function (e) {
            if ($(this).is(':checked')) {
                $('#collectiveTransferReturn').click();
            }
            listChAt.total();
        });

        listChAt.$modalHotel.on('click', '.btn-booking', function (e) {
            e.preventDefault();
            listChAt.$modalHotel.modal('hide');

            const $modalBooking = listChAt.$modalBooking;
            $modalBooking.modal('show');

            let $body = listChAt.$bookingForm;
            const $unit = $(this).closest('.unit');
            const params = JSON.parse($unit.attr('data-params'));

            $body = $body.replace(/\{\$params\}/g, JSON.stringify({productCode : params.productCode}).replace(/"/g, '&quot;'));
            $body = $body.replace(/\{\$hotelName\}/g, params.hotel.name);
            $body = $body.replace(/\{\$hotelImage\}/g, params.hotel.image);
            $body = $body.replace(/\{\$guests\}/g, params.guests);
            $body = $body.replace(/\{\$period\}/g, params.dateFrom + ' - ' + params.dateTo);
            $body = $body.replace(/\{\$unitName\}/g, params.unit.name);
            $body = $body.replace(/\{\$boardName\}/g, params.unit.boardName);
            $body = $body.replace(/\{\$hotelPrice\}/g, params.unit.total);

            $body = $body.replace(/\{\$departureFlight\}/g, params.flight.departure.origin +' - '+ params.flight.departure.destination);
            $body = $body.replace(/\{\$departureFlightDepartureDateTime\}/g, functions.formatDate(params.flight.departure.departureDate) +' '+ params.flight.departure.departureTime);
            $body = $body.replace(/\{\$departureFlightArrivalDateTime\}/g, functions.formatDate(params.flight.departure.arrivalDate) +' '+ params.flight.departure.arrivalTime);
            $body = $body.replace(/\{\$departureFlightPrice\}/g, params.flight.departure.total);

            $body = $body.replace(/\{\$returnFlight\}/g, params.flight.return.origin +' - '+ params.flight.return.destination);
            $body = $body.replace(/\{\$returnFlightDepartureDateTime\}/g, functions.formatDate(params.flight.return.departureDate) +' '+ params.flight.return.departureTime);
            $body = $body.replace(/\{\$returnFlightArrivalDateTime\}/g, functions.formatDate(params.flight.return.arrivalDate) +' '+ params.flight.return.arrivalTime);
            $body = $body.replace(/\{\$returnFlightPrice\}/g, params.flight.return.total);

            let $supplements = '';
            $.each(params.mandatory, function( index, mandatory ) {
                let $bookingFormSupplements = listChAt.$bookingFormSupplements;

                $bookingFormSupplements = $bookingFormSupplements.replace(/\{\$supplementId\}/g, index);
                $bookingFormSupplements = $bookingFormSupplements.replace(/\{\$supplementText\}/g, mandatory.text);
                $bookingFormSupplements = $bookingFormSupplements.replace(/\{\$supplementPrice\}/g, mandatory.total);
                $bookingFormSupplements = $bookingFormSupplements.replace(/\{\$supplementCalc\}/g, JSON.stringify({
                    total: mandatory.total,
                    isOptional: 0,
                    componentCode: mandatory.componentCode,
                    productCode: mandatory.productCode
                }).replace(/"/g, '&quot;'));

                $supplements += $bookingFormSupplements;
            });

            $body = $body.replace(/\{\$supplements\}/g, $supplements);

            let collectiveDeparture = listChAt.getCollectiveTransfer(params.transfer.departure);
            let collectiveReturn = listChAt.getCollectiveTransfer(params.transfer.return);

            let privateDeparture = listChAt.getPrivateTransfer(params.transfer.departure);
            let privateReturn = listChAt.getPrivateTransfer(params.transfer.return);

            if (collectiveDeparture) {
                $body = $body.replace(/\{\$departureCollectiveTransferPrice\}/g, collectiveDeparture.total);
            }

            //console.log(collectiveDeparture);

            if (collectiveReturn) {
                $body = $body.replace(/\{\$returnCollectiveTransferPrice\}/g, collectiveReturn.total);
            }

            if (privateDeparture) {
                $body = $body.replace(/\{\$departurePrivateTransferPrice\}/g, privateDeparture.total);
            }

            if (privateReturn) {
                $body = $body.replace(/\{\$returnPrivateTransferPrice\}/g, privateReturn.total);
            }

            $modalBooking.find('.modal-body').html($body);

            if (collectiveDeparture) {
                $modalBooking.find('#collectiveTransferDeparture').attr('checked', true);
                $modalBooking.find('.calc-item-transfer-collective-departure').attr('data-calc', JSON.stringify({total: collectiveDeparture.total, isOptional: 0, componentCode: collectiveDeparture.componentCode, productCode: collectiveDeparture.productCode, serviceCode: collectiveDeparture.serviceCode}));
            }

            if (collectiveReturn) {
                $modalBooking.find('#collectiveTransferReturn').attr('checked', true);
                $modalBooking.find('.calc-item-transfer-collective-return').attr('data-calc', JSON.stringify({total: collectiveReturn.total, isOptional: 0, componentCode: collectiveReturn.componentCode, productCode: collectiveReturn.productCode, serviceCode: collectiveReturn.serviceCode}));
            }

            if (privateDeparture) {
                $modalBooking.find('.calc-item-transfer-private-departure').attr('data-calc', JSON.stringify({total: privateDeparture.total, isOptional: 1, componentCode: privateDeparture.componentCode, productCode: privateDeparture.productCode, serviceCode: privateDeparture.serviceCode}));
            }

            if (privateReturn) {
                $modalBooking.find('.calc-item-transfer-private-return').attr('data-calc', JSON.stringify({total: privateReturn.total, isOptional: 1, componentCode: privateReturn.componentCode, productCode: privateReturn.productCode, serviceCode: privateReturn.serviceCode}));
            }

            $modalBooking.find('.calc-item-hotel').attr('data-calc', JSON.stringify({
                total: params.unit.total,
                isOptional: 0,
                componentCode: params.hotel.componentCode,
                productCode: params.hotel.productCode,
                boardCode: params.unit.boardCode,
                unitCode: params.unit.code
            }));

            /* console.log({
                 total: params.unit.total,
                 isOptional: 0,
                 componentCode: params.hotel.componentCode,
                 productCode: params.hotel.productCode
             });*/

            $modalBooking.find('.calc-item-flight-departure').attr('data-calc', JSON.stringify({
                total: params.flight.departure.total,
                isOptional: 0,
                componentCode: params.flight.departure.componentCode,
                productCode: params.flight.departure.productCode
            }));

            $modalBooking.find('.calc-item-flight-return').attr('data-calc', JSON.stringify({
                total: params.flight.return.total,
                isOptional: 0,
                componentCode: params.flight.return.componentCode,
                productCode: params.flight.return.productCode
            }));

            listChAt.$modalBooking.find('.total-amount').text(params.unit.packageTotal + params.unit.total);

            //listChAt.total();
        });

        return listChAt;
    },
    setLoadingMode() {
        if(! this.loading) {
            this.loading = true;

            // form submit btn
            (this.$form).find('button').prop('disabled', true);

            if ( ! this.$spinner.length) {
                $('<div class="spinner d-none"><div class="spinner-border text-secondary" role="status" style="width: 4rem; height: 4rem;"><span class="sr-only">Loading...</span></div></div>').insertBefore('.list-items');
                this.$spinner = $('.spinner');
            }

            this.$spinner.removeClass('d-none');
            this.$spinner.addClass('d-flex justify-content-center');
            this.$listItems.addClass('d-none');
            $('.paginate').addClass('d-none');
        }
    },
    unsetLoadingMode() {
        if(this.loading) {
            this.loading = false;

            // form submit btn
            (this.$form).find('button').prop('disabled', false);

            this.$spinner.removeClass('d-flex justify-content-center');
            this.$spinner.addClass('d-none');
            this.$listItems.removeClass('d-none');
            $('.paginate').removeClass('d-none');

            //functions.scrollToElement(this.$listItems, 100);
        }
    },
    setQueryParams() {
        this._params.dateFrom = this.params.dateFrom;
        this._params.nights = this.params.nights;
        this._params.destination = this.params.destination;
        this._params.departureFrom = this.params.departureFrom;
        this._params.guests = this.params.guests;
    },
    find() {

        if (! (this.params.dateFrom && this.params.nights && this.params.destination && this.params.departureFrom && this.params.guests))
        {
            listChAt.$listItems.html('<div class="text-center m-3 m-lg-4 my-lg-5"> ' +
                '<i class="las la-search la-4x text-primary mb-3"></i> ' +
                '<div class="h5 fw-bold" style="line-height: 1.4;"> ' +
                'Potražite slobodne kapacitete pomoću tražilice. ' +
                '</div> ' +
                '</div>');

            listChAt.$pagination.html('');
            listChAt.setQueryParams();

            return;
        }

        if ((this.params.dateFrom == this._params.dateFrom &&
            this.params.nights == this._params.nights &&
            this.params.destination == this._params.destination &&
            this.params.departureFrom == this._params.departureFrom &&
            this.params.guests == this._params.guests
        )) {
            return;
        }

        listChAt.$listItems.html('');
        listChAt.$pagination.html('');

        listChAt.setLoadingMode();

        $.get('/services/ch_at/', $.extend({}, {action: 'availability'}, this.params)).then((response) => {

            listChAt.unsetLoadingMode();
            listChAt.setQueryParams();
            listChAt.response = response;

            let total = 0;
            listChAt.prepareCodes();

            $.each(listChAt.response.productList, function( index, productListItem ) {
                if (productListItem.productSubType === 'ESTANCIA') {
                    $.each(productListItem.optionList, function( index, optionListItem ) {
                        $.each(optionListItem.componentList, function( index, componentListItem ) {
                            if (componentListItem.componentType === 'HOTEL') {
                                $.each(componentListItem.productList, function( index, hotel ) {
                                    listChAt.prepareHotelItem(total+1, productListItem.productCode,  componentListItem.componentCode, optionListItem, hotel);
                                    total++;
                                });
                            }
                        });
                    });
                }
            });

            if (total > 0) {
               listChAt.paginate(this.params._page ? this.params._page : 1);
            }
        })
    },
    prepareCodes() {
        $.each(listChAt.response.productList, function( index, productListItem ) {
            if (productListItem.productSubType == 'ESTANCIA') {
                $.each(productListItem.optionList, function( index, optionListItem ) {
                    $.each(optionListItem.componentList, function( index, componentListItem ) {

                        $.each(componentListItem.productList, function( index, productList ) {
                            if ( ! productList.productCode) {
                                productList.productCode = productList.productType + Math.floor(Math.random() * (1000000 - 1 + 1)) + 1;
                            }

                            if (productList.serviceTypeName === "Transfers") {

                                $.each(productList.serviceOptionList, function( index, serviceOptionList ) {
                                    serviceOptionList.serviceCode = Math.floor(Math.random() * (1000000 - 1 + 1)) + 1;
                                });
                            }
                        });
                    });
                });
            }
        });
    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true);

        let to = page * 5;
        let from = to - 5;

        listChAt.$listItems.find('.hotel').addClass("d-none");
        listChAt.$listItems.find('.hotel').slice(from,to).removeClass("d-none");

        listChAt.$pagination.html(pagination({
            currentPage: this.params._page,
            total: listChAt.$listItems.find('.hotel').length,
            perPage: 5,
        }));
    },
    prepareHotelItem(index, packageCode, componentCode, packageData, hotelItem) {

        //console.log(packageData)

        let stars = listChAt.prepareHotelStars(hotelItem);
        let minPrice = listChAt.prepareMinPrice(hotelItem);

        let flight = {
            departure: listChAt.getDepartureFlightData(packageData),
            return: listChAt.getReturnFlightData(packageData)
        };

        let transfer = {
            departure: listChAt.getDepartureTransferData(packageData, flight.departure.arrivalDate),
            return: listChAt.getReturnTransferData(packageData, flight.return.departureDate)
        };

        //console.log('prepareHotelItem > flight', flight);
        //console.log('prepareHotelItem > transfer', transfer);

        let mandatory = listChAt.getMandatorySupplements(packageData);

        let collectiveDeparture = $.grep(transfer.departure, function (transfer, index) {
            return transfer.private === false;
        })[0];

        let collectiveReturn = $.grep(transfer.return, function (transfer, index) {
            return transfer.private === false;
        })[0];

        let packageTotal = +packageData.price.total.amount;

        /*if (flight.departure.total) {
            packageTotal += flight.departure.total;
        }

        if (flight.return.total) {
            packageTotal += flight.return.total;
        }

        if (collectiveDeparture && collectiveDeparture.total) {
            packageTotal += collectiveDeparture.total;
        }

        if (collectiveReturn && collectiveReturn.total) {
            packageTotal += collectiveReturn.total;
        }

        $.each(mandatory, function( index, supplement ) {
            packageTotal += supplement.total;
        });*/

        minPrice += packageTotal;

        let units = [];
        let _minPrice = 0;
        $.each(hotelItem.mealPlanList, function( index, unitPerBoard ) {
            $.each(unitPerBoard.hotelOptionList, function (index, unit) {

                let _price = +unit.roomList[0].roomAmount.amount;

                if ( ! _minPrice || _price < _minPrice) {
                    _minPrice = _price;
                }

                /*console.log('prepareHotelItem > unit', unit, {
                    name: unit.roomList[0].roomTypeName,
                    total: +unit.roomList[0].roomAmount.amount,
                    packageTotal: packageTotal,
                    code: unit.roomList[0].roomTypeCode,
                    boardName: unitPerBoard.mealPlanName.replace(/(\r\n|\n|\r)/gm, "")
                });*/

                units.push({
                    name: unit.roomList[0].roomTypeName,
                    total: _price,
                    packageTotal: packageTotal,
                    code: unit.roomList[0].roomTypeCode,
                    boardName: unitPerBoard.mealPlanName.replace(/(\r\n|\n|\r)/gm, ""),
                    boardCode: unitPerBoard.mealPlanCode
                });
            });
        });

        minPrice += _minPrice;

        let params = $.extend({},{
            hotel: {
                productCode: hotelItem.productCode,
                componentCode: componentCode,
                minPrice: minPrice,
                units: units
            },
            flight: flight,
            transfer: transfer,
            mandatory: mandatory,
            total: packageTotal,
            productCode: packageCode
        });

        let $hotel = this.$hotelItem;
        $hotel = $hotel.replace(/\{\$hotelIdx\}/g, index);
        $hotel = $hotel.replace(/\{\$hotelName\}/g, hotelItem.productName);
        $hotel = $hotel.replace(/\{\$hotelImage\}/g, hotelItem.imageUrl);
        $hotel = $hotel.replace(/\{\$hotelCity\}/g, hotelItem.cityName);
        $hotel = $hotel.replace(/\{\$hotelDescription\}/g, hotelItem.hotelDescription);
        $hotel = $hotel.replace(/\{\$hotelPrice\}/g, minPrice);
        $hotel = $hotel.replace(/\{\$stars\}/g, stars);
        $hotel = $hotel.replace(/\{\$params\}/g, JSON.stringify(params).replace(/"/g, '&quot;'));

        this.$listItems.append($hotel);

    },
    prepareHotel(params) {

        let flight = params.flight;
        let transfer = params.transfer;
        let mandatory = params.mandatory;
        let productCode = params.productCode;

        let hotel = params.hotel;

        let guests = listChAt.params.guests.split(',');
        guests = +guests[0] + +guests[1];

        let dateFrom = functions.formatDate(listChAt.params.dateFrom);
        let dateTo = new Date(listChAt.params.dateFrom);
        dateTo = functions.formatDate(dateTo.setDate(dateTo.getDate() + +this.params.nights ));

        let $units = '';

        $.get('/services/ch_at/', $.extend({}, {action: 'hotel', hotelCode: hotel.productCode}, this.params)).then((response) => {

            let hotelData = {
                name: response.product.name,
                image: response.product.imageList[0].value,
                productCode: params.hotel.productCode,
                componentCode: params.hotel.componentCode,
            };

            let $unitElem = $(listChAt.$hotel).find('.units').html();
            $.each(hotel.units, function( index, unitData ) {

                    let params = $.extend({}, {hotel: hotelData}, {unit: unitData}, {
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        guests: guests,
                    }, {flight: flight}, {transfer: transfer}, {mandatory: mandatory}, {productCode: productCode});

                    let $_unitElem = $unitElem;
                    $_unitElem = $_unitElem.replace(/\{\$unitName\}/g, unitData.name+', '+unitData.boardName);
                    $_unitElem = $_unitElem.replace(/\{\$unitPrice\}/g, unitData.total + unitData.packageTotal);
                    $_unitElem = $_unitElem.replace(/\{\$params\}/g, JSON.stringify(params).replace(/"/g, '&quot;'));
                    $_unitElem = $_unitElem.replace('unit-placeholder d-none', '');

                    $units += $_unitElem;
            });

            let $amenity = '';
            let hasTv = false;
            $.each(response.product.amenityList, function( index, amenity ) {

                if ((amenity.amenityID == 21 || amenity.amenityID == 22) && ! hasTv) {
                    hasTv = true;
                    $amenity +=
                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-tv la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col d-flex align-items-center">\n' +
                        '                            <div>\n' +
                        '                                Tv\n' +
                        '                            </div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n' ;
                } else if (amenity.amenityID == 45) {
                    $amenity +=
                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-wifi la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col">\n' +
                        '                            <div class="mt-1">\n' +
                        '                                Internet: Da\n' +
                        '                            </div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n' ;
                } else if (false) {
                    $amenity +=
                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-fan la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col d-flex align-items-center">\n' +
                        '                            <div>\n' +
                        '                                Klima\n' +
                        '                            </div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n';
                }  else if (false) {
                    $amenity +=
                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-paw la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col d-flex align-items-center">\n' +
                        '                            <div>\n' +
                        '                                Kućni ljubimci\n' +
                        '                            </div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n' ;
                }  else if (false) {
                    $amenity +=

                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-parking la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col">\n' +
                        '                            <div class="mt-1">\n' +
                        '                                Parking dostupan: Da\n' +
                        '                            </div>\n' +
                        '                            <div class="small"></div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n';
                }  else if (false) {
                    $amenity +=
                        '                <div class="col-lg-4 mb-3 mb-lg-4">\n' +
                        '                    <div class="row no-gutters">\n' +
                        '                        <div class="col-auto">\n' +
                        '                            <i class="las la-swimming-pool la-2x text-primary mr-3"></i>\n' +
                        '                        </div>\n' +
                        '                        <div class="col">\n' +
                        '                            <div class="mt-1">\n' +
                        '                                Bazen: Da\n' +
                        '                            </div>\n' +
                        '                            <div class="small"></div>\n' +
                        '                        </div>\n' +
                        '                    </div>\n' +
                        '                </div>\n';
                }
            });

            let gallery = [];
            $.each(response.product.imageList, function( index, image ) {
                gallery.push({src: image.value, thumb: image.value});
            });

            let $hotel = listChAt.$hotel;
            $hotel = $hotel.replace(/\{\$hotelName\}/g, response.product.name);
            $hotel = $hotel.replace(/\{\$hotelImage1\}/g, response.product.imageList[0].value);
            $hotel = $hotel.replace(/\{\$hotelImage2\}/g, response.product.imageList.length > 1 ? response.product.imageList[1].value : '');
            $hotel = $hotel.replace(/\{\$hotelImage3\}/g, response.product.imageList.length > 2 ? response.product.imageList[2].value : '');
            $hotel = $hotel.replace(/\{\$hotelCode\}/g, response.product.productCode);
            $hotel = $hotel.replace(/\{\$hotelcode\}/g, response.product.productCode);
            $hotel = $hotel.replace(/\{\$hotelPlace\}/g, response.product.address.cityName);
            $hotel = $hotel.replace(/\{\$minPrice\}/g, hotel.minPrice);
            $hotel = $hotel.replace(/\{\$hotelDescription\}/g, response.product.descriptionList && response.product.descriptionList[0] ? response.product.descriptionList[0].text : '');
            $hotel = $hotel.replace(/\{\$latitude\}/g, response.product.address.location.latitude);
            $hotel = $hotel.replace(/\{\$longitude\}/g, response.product.address.location.longitude);
            $hotel = $hotel.replace(/\{\$units\}/g, $units);
            $hotel = $hotel.replace(/\{\$gallery\}/g, JSON.stringify(gallery).replace(/"/g, '&quot;'));

            listChAt.$modalHotel.find(".modal-body").html($hotel);
            listChAt.$modalHotel.modal('show');

            listChAt.$modalHotel[0].addEventListener('shown.bs.modal', function () {
                if (+listChAt.$modalHotel.find(".ch-at-desc-block").height() < +listChAt.$modalHotel.find(".ch-at-desc").height()) {
                    listChAt.$modalHotel.find('[data-more]').removeClass('d-none');
                }
            })

        })
    },
    getDestinations() {

        $.post('/services/ch_at/', {action: 'destinations'}).then(response => {
            //(response);
            this.prepareDestinations(response);
        });

        return listChAt;
    },
    prepareDestinations(response) {
        const a = {};
        $.each(response.destinationList, function( index1, level1 ) {
            $.each(level1.childDestinationList, function( index2, level2 ) {

                $.each(level2.childDestinationList, function( index3, level3 ) {
                    $.each(level3.childDestinationList, function( index4, level4 ) {
                        var child = $.map(level4.zoneProductList, function( zoneProductList ) {
                            if (zoneProductList.subProductType == "ESTANCIA") {
                                return zoneProductList;
                            }
                        });

                        if (child.length) {
                            if ( ! a[level1.destinationCode]) {
                                a[level1.destinationCode] = {
                                    destinationCode: level1.destinationCode,
                                    destinationName: level1.destinationName,
                                    destinationType: level1.destinationType,
                                    destinationList: {}
                                };
                            }
                            if ( ! a[level1.destinationCode].destinationList[level2.destinationCode]) {
                                a[level1.destinationCode].destinationList[level2.destinationCode] = {};

                                a[level1.destinationCode].destinationList[level2.destinationCode] = {
                                    destinationCode: level2.destinationCode,
                                    destinationName: level2.destinationName,
                                    destinationType: level2.destinationType,
                                    destinationList: {}
                                };
                            }
                            if ( ! a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode]) {
                                a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode] = {};

                                a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode] = {
                                    destinationCode: level3.destinationCode,
                                    destinationName: level3.destinationName,
                                    destinationType: level3.destinationType,
                                    destinationList: {}
                                };
                            }
                            if ( ! a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode].destinationList[level4.destinationCode]) {
                                a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode].destinationList[level4.destinationCode] = {};

                                a[level1.destinationCode].destinationList[level2.destinationCode].destinationList[level3.destinationCode].destinationList[level4.destinationCode] = {
                                    destinationCode: level4.destinationCode,
                                    destinationName: level4.destinationName,
                                    destinationType: level4.destinationType,
                                    zoneProductList: child
                                };
                            }
                        }
                    });
                });
            });
        });


        const $destination = this.$destination;
        const $departureFrom = this.$departureFrom;
        const $datepicker = this.$datepicker;

        Object.keys(a).forEach(function (key) {

            $destination.append($("<option></option>").attr("value", a[key].destinationCode).text(a[key].destinationName));

            let level1 = a[key].destinationList;
            Object.keys(level1).forEach(function (key1) {
                $destination.append($("<option></option>").attr("value", level1[key1].destinationCode).text("" + level1[key1].destinationName));

                let level2 = level1[key1].destinationList;
                Object.keys(level2).forEach(function (key2) {
                    $destination.append($("<option></option>").attr("value", level2[key2].destinationCode).html("&nbsp;&nbsp;&nbsp;&nbsp;" + level2[key2].destinationName));

                    let level3 = level2[key2].destinationList;
                    Object.keys(level3).forEach(function (key3) {
                        $destination.append($("<option></option>").attr("value", level3[key3].destinationCode).attr('data-departures', JSON.stringify(level3[key3].zoneProductList[0].referencePriceList)).html("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + level3[key3].destinationName));
                    });
                });
            });
        });

        $datepicker._flatpickr = flatpickr($datepicker.find('[name="dateFrom"]'), {
            altInput: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            closeOnSelect: true,
            disableMobile: true,
            onOpen: (selected, dateStr, instance) => {

            },
            onClose: (selected, dateStr, instance) => {

            },
            onChange: (selected, dateStr, instance) => {
                let nights = [];

                $.each(listChAt.currentDates, function(index, item ) {
                    if (dateStr === item.dateFrom) {
                        nights.push(item.numberOfNights)
                    }
                });

                const $nights = this.$nights;
                $nights.val('');
                $nights.find('option').remove();
                $nights.append($("<option></option>").attr("value", "").text('----'));
                $.each(nights, function( index, item ) {
                    $nights.append($("<option></option>").attr("value", item).text(item));
                });

            },
            onReady: (dateObj, dateStr, instance) => {

            },
        });

        $destination.on('change', function() {
            let departures = JSON.parse($("option[value='"+this.value+"']").attr('data-departures'));

            /*$departureFrom.val('').trigger('change');

            listChAt.$nights.val('').trigger('change');
            listChAt.$form.find('[name="guests"]').val('').trigger('change');*/

            $departureFrom.find('option').remove();
            $departureFrom.append($("<option></option>").attr("value", "").text('----'));
            $.each(departures, function( index, item ) {
                if ($departureFrom.find("option[value='"+item.iataOrigin+"']").length) {
                    let e = JSON.parse($departureFrom.find("option[value='"+item.iataOrigin+"']").attr('data-departures'));
                    e.push({
                        date: item.fromDate,
                        numberOfNights: item.numberOfNights
                    });
                    $departureFrom.find("option[value='"+item.iataOrigin+"']").attr('data-departures', JSON.stringify(e));
                } else {
                    $departureFrom.append($("<option></option>").attr('data-departures', JSON.stringify([{
                        date: item.fromDate,
                        numberOfNights: item.numberOfNights
                    }])).attr("value", item.iataOrigin).text(item.iataOrigin));
                }
            });
        });

        $datepicker._flatpickr.set('clickOpens', false);

        $departureFrom.on('change', function() {
            const dates = JSON.parse($("option[value='"+this.value+"']").attr('data-departures'));
            let enable = [];
            $.each(dates, function( index, item ) {
                dates[index].dateFrom = item.date.substring(0,10)
                enable.push(dates[index].dateFrom);
            });

            listChAt.currentDates = dates;

            $datepicker._flatpickr.clear();
            $datepicker._flatpickr.set('enable', enable);
            $datepicker._flatpickr.set('clickOpens', true);

        });

        let params = functions.getUrlData(true);
        listChAt.params = params;

        if (params.destination) {
            $destination.val(params.destination);
            $destination.change();

            setTimeout(() => {
                if (params.departureFrom) {
                    $departureFrom.val(params.departureFrom);
                    $departureFrom.change();

                    setTimeout(() => {
                        if (params.dateFrom) {
                            listChAt.$dateFrom.val(params.dateFrom);
                            $datepicker._flatpickr.setDate(params.dateFrom, true);

                            setTimeout(() => {
                                if (params.nights) {
                                    listChAt.$nights.val(params.nights);
                                    listChAt.find();
                                }
                            }, 50);
                        }
                    }, 50);
                }
            }, 50);
        }
        if (params.guests) {
            this.$form.find('[name="guests"]').val(params.guests);
            this.$form.find('[name="guests"]').change();
        }

        setTimeout(() => {
            if( ! functions.isMobile()) {
                this.$form.on('change', e => {
                    e.preventDefault();
                    this.params = functions.getDataForUrl(functions.getFormData(this.$form));
                    functions.setUrlData(this.params, true, true);
                });
            }
        }, 200);

        $(window).on('hashchange', e => {
            functions.scrollToElement(this.$listItems, 100);
            this.find();
        });

        $('.datepicker-actions').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            $datepicker._flatpickr.clear();
        });

        if (! (this.params.dateFrom && this.params.nights && this.params.destination && this.params.departureFrom && this.params.guests))
        {
            this.$listItems.html('<div class="text-center m-3 m-lg-4 my-lg-5"> ' +
                '<i class="las la-search la-4x text-primary mb-3"></i> ' +
                '<div class="h5 fw-bold" style="line-height: 1.4;"> ' +
                'Potražite slobodne kapacitete pomoću tražilice. ' +
                '</div> ' +
                '</div>');

            return;
        }
    },

    prepareHotelStars(hotelItem) {
        switch(hotelItem.categoryCode) {
            case "5EST":
                return '<i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i>';
            case "4EST":
                return '<i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i>';
            case "3EST":
                return '<i class="las la-star text-warning"></i><i class="las la-star text-warning"></i><i class="las la-star text-warning"></i>';
            case "2EST":
                return '<i class="las la-star text-warning"></i><i class="las la-star text-warning"></i>';
            case "1EST":
                return '<i class="las la-star text-warning"></i>';
        }
        return '';
    },
    prepareMinPrice(hotelItem) {
        let minPrice = null;
        $.each(hotelItem.mealPlanList, function( index, unitPerBoard ) {
            $.each(unitPerBoard.hotelOptionList, function( index, unit ) {
                if ((minPrice === null || minPrice > +unit.optionPrice.total.amount) && +unit.optionPrice.total.amount > 0) {
                    minPrice = unit.optionPrice.total.amount;
                }
            });
        });
        return minPrice;
    },
    total() {
        /*let total = 0.00;
        listChAt.$modalBooking.find("*[data-calc]").each(function (index) {
            if ($(this).attr('data-calc') && ! $(this).closest('.calc-item-supplement').length) {
                let item = JSON.parse($(this).attr('data-calc'));
                if (item.isOptional) {
                    let $checkbox = $(this).find('input[type="checkbox"]');
                    if ($checkbox.is(':checked')) {
                        total += +item.total;
                    }
                } else {
                    total += +item.total;
                }
            }
        });*/

        listChAt.$modalBooking.find('.total-amount').text(total);
    },

    getCollectiveTransfer(transfers) {
        return $.grep(transfers, function (transfer, index) {
            return transfer.private === false;
        })[0];
    },

    getPrivateTransfer(transfers) {
        return $.grep(transfers, function (transfer, index) {
            return transfer.private === true;
        })[0];
    },

    getMandatorySupplements(packageData) {
        let data = [];
        $.each(packageData.componentList, function( index, componentList ) {

            if (componentList.componentType == "SERVICE" && componentList.mandatory === true) {
               $.each(componentList.productList, function( index, productList ) {

                    if (productList.productType == "SERVICE" && productList.serviceTypeName != "Transfers" ) {

                        let price;
                        if (productList.serviceOptionList[0].servicePrice.priceId) {
                            price = listChAt.response.priceInfoList[productList.serviceOptionList[0].servicePrice.priceId];
                        } else {
                            price = productList.serviceOptionList[0].servicePrice;
                        }

                        data.push({
                            componentCode: componentList.componentCode,
                            productCode: productList.productCode,
                            text: productList.productName,
                            total: +price.total.amount
                        })
                    }
                });
            }
        });

        return data;
    },

    getDepartureTransferData(packageData, date) {
        let transferData = [];
        $.each(packageData.componentList, function( index, componentList ) {

            if (componentList.componentType == "SERVICE" && componentList.mandatory == true &&
                componentList.productList[0].serviceTypeName == "Transfers" &&
                componentList.productList[0].firstServiceDate.substring(0,10) == date) {

               $.each(componentList.productList[0].serviceOptionList, function( index, serviceOptionList ) {

                   let price;
                   if (serviceOptionList.servicePrice.priceId) {
                       price = listChAt.response.priceInfoList[serviceOptionList.servicePrice.priceId];
                   } else {
                       price = serviceOptionList.servicePrice;
                   }

                   if (serviceOptionList.optionName == "Traslado Colectivo" || serviceOptionList.optionName == "Collective Transfer") {
                       transferData.push({
                           componentCode: componentList.componentCode,
                           productCode: componentList.productList[0].productCode,
                           serviceCode: serviceOptionList.serviceCode,
                           private: false,
                           total: +price.total.amount
                       })
                   } else if (serviceOptionList.optionName == "Private Transfer") {
                       transferData.push({
                           componentCode: componentList.componentCode,
                           productCode: componentList.productList[0].productCode,
                           serviceCode: serviceOptionList.serviceCode,
                           private: true,
                           total: +price.total.amount
                       })
                   }
                });
            }
        });

        return transferData;
    },

    getReturnTransferData(packageData, date) {
        let transferData = [];
        $.each(packageData.componentList, function( index, componentList ) {

            /*console.log('getReturnTransferData > componentType', componentList.componentType);
            console.log('getReturnTransferData > productList[0]', componentList.productList[0]);
            console.log('getReturnTransferData > serviceTypeName', componentList.productList[0].serviceTypeName);
            console.log('getReturnTransferData > date', componentList.productList[0].lastServiceDate.substring(0,10), date);*/

            if (componentList.componentType == "SERVICE" && componentList.mandatory == true && componentList.productList[0].serviceTypeName == "Transfers" && componentList.productList[0].lastServiceDate.substring(0,10) == date) {
                $.each(componentList.productList[0].serviceOptionList, function( index, serviceOptionList ) {

                    let price;
                    if (serviceOptionList.servicePrice.priceId) {
                        price = listChAt.response.priceInfoList[serviceOptionList.servicePrice.priceId];
                    } else {
                        price = serviceOptionList.servicePrice;
                    }

                    if (serviceOptionList.optionName == "Traslado Colectivo" || serviceOptionList.optionName == "Collective Transfer") {
                        transferData.push({
                            componentCode: componentList.componentCode,
                            productCode: componentList.productList[0].productCode,
                            serviceCode: serviceOptionList.serviceCode,
                            private: false,
                            total: +price.total.amount
                        })
                    } else if (serviceOptionList.optionName == "Private Transfer") {
                        transferData.push({
                            componentCode: componentList.componentCode,
                            productCode: componentList.productList[0].productCode,
                            serviceCode: serviceOptionList.serviceCode,
                            private: true,
                            total: +price.total.amount
                        })
                    }
                });
            }
        });

        return transferData;
    },

    getDepartureFlightData(packageData) {
        let flightData = {};
        $.each(packageData.componentList, function( index, componentList ) {
            if (componentList.componentType == "TRANSPORT" && componentList.productList[0].itineraryList[0].itineraryType == "OUTBOUND") {
                let flightArrivalDepartureData = componentList.productList[0].itineraryList[0].optionList[0].segmentList[0];
                let price = null;

                //console.log('getDepartureFlightData > componentList:', componentList);
                //console.log('flightArrivalDepartureData > flightArrivalDepartureData:', flightArrivalDepartureData);

                if (flightArrivalDepartureData.idSegment && flightArrivalDepartureData.idSegment != "0") {
                    let segment = listChAt.response.segmentList[flightArrivalDepartureData.idSegment];
                    //console.log('flightArrivalDepartureData > segment:', segment);

                    if (componentList.productList[0].itineraryList[0].optionList[0].price.priceId) {
                        price = listChAt.response.priceInfoList[componentList.productList[0].itineraryList[0].optionList[0].price.priceId];
                        //console.log('flightArrivalDepartureData > price:', price);
                    } else {
                        price = componentList.productList[0].itineraryList[0].optionList[0].price;
                    }

                    flightData = {
                        componentCode: componentList.componentCode,
                        productCode: componentList.productList[0].productCode,
                        origin: segment.origin,
                        destination: segment.destination,
                        departureDate: segment.departureDateTime.substring(0,10),
                        departureTime: segment.departureDateTime.substring(11,16),
                        arrivalDate: segment.arrivalDateTime.substring(0,10),
                        arrivalTime: segment.arrivalDateTime.substring(11,16),
                        total: +price.total.amount
                    }

                } else {
                    flightData = {
                        componentCode: componentList.componentCode,
                        productCode: componentList.productList[0].productCode,
                        origin: flightArrivalDepartureData.origin,
                        destination: flightArrivalDepartureData.destination,
                        departureDate: flightArrivalDepartureData.departureDateTime.substring(0,10),
                        departureTime: flightArrivalDepartureData.departureDateTime.substring(11,16),
                        arrivalDate: flightArrivalDepartureData.arrivalDateTime.substring(0,10),
                        arrivalTime: flightArrivalDepartureData.arrivalDateTime.substring(11,16),
                        total: +componentList.productList[0].itineraryList[0].optionList[0].price.total.amount
                    }
                }
            }
        });
        return flightData;
    },
    getReturnFlightData(packageData) {
        let flightData = {};
        $.each(packageData.componentList, function( index, componentList ) {
            if (componentList.componentType == "TRANSPORT" && componentList.productList[0].itineraryList[0].itineraryType == "INBOUND") {
                let flightArrivalDepartureData = componentList.productList[0].itineraryList[0].optionList[0].segmentList[0];
                let price = null;

                if (flightArrivalDepartureData.idSegment && flightArrivalDepartureData.idSegment != "0") {
                    let segment = listChAt.response.segmentList[flightArrivalDepartureData.idSegment];
                    //console.log('flightArrivalDepartureData > segment:', segment);

                    if (componentList.productList[0].itineraryList[0].optionList[0].price.priceId) {
                        price = listChAt.response.priceInfoList[componentList.productList[0].itineraryList[0].optionList[0].price.priceId];
                        //console.log('flightArrivalDepartureData > price:', price);
                    } else {
                        price = componentList.productList[0].itineraryList[0].optionList[0].price;
                    }

                    flightData = {
                        componentCode: componentList.componentCode,
                        productCode: componentList.productList[0].productCode,
                        origin: segment.origin,
                        destination: segment.destination,
                        departureDate: segment.departureDateTime.substring(0,10),
                        departureTime: segment.departureDateTime.substring(11,16),
                        arrivalDate: segment.arrivalDateTime.substring(0,10),
                        arrivalTime: segment.arrivalDateTime.substring(11,16),
                        total: +price.total.amount
                    }

                } else {
                    flightData = {
                        componentCode: componentList.componentCode,
                        productCode: componentList.productList[0].productCode,
                        origin: flightArrivalDepartureData.origin,
                        destination: flightArrivalDepartureData.destination,
                        departureDate: flightArrivalDepartureData.departureDateTime.substring(0,10),
                        departureTime: flightArrivalDepartureData.departureDateTime.substring(11,16),
                        arrivalDate: flightArrivalDepartureData.arrivalDateTime.substring(0,10),
                        arrivalTime: flightArrivalDepartureData.arrivalDateTime.substring(11,16),
                        total: +componentList.productList[0].itineraryList[0].optionList[0].price.total.amount
                    };
                }
            }
        });
        return flightData;
    },
};